/**
 * Specifies the negotiation method to be used.
 * tag: 2115
 * @readonly
 * @enum {number} (int)
 */
export enum NegotiationMethod {
  AutoSpot = 0,
  NegotiatedSpot = 1,
  PhoneSpot = 2,
}
